import styled from "styled-components";
import { colors } from "colors";

export const TabsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
  hr {
    width: 26px;
    transform: rotate(90deg);
    border: none;
    height: 1px;
    background-color: ${colors.grayWhite};
    margin: 0px -6px;
  }
  button {
    height: 35px;
    padding: 6.65px 13.31px 6.65px 13.31px;
    border-radius: 5px;
    gap: 6.65px;
    background-color: ${colors.darkGray2};
    border: none;
    box-shadow: ${colors.boxShadow2};
    color: ${colors.white2};
    &:hover {
      background-color: ${colors.white};
      color: ${colors.black};
    }
    &.selected {
      background-color: ${colors.white};
      color: ${colors.black};
    }
  }
`;

export const InnerSettingsWrapper = styled.div`
  width: 90%;
  margin: 0 auto;
  border-radius: 10px;
  border: 1px solid #e4e7e5;
`;

export const SettingWrapper = styled.div`
  width: 100%;
  height: auto;
  min-height: 700px;
  background-color: white;
  padding-top: 40px;
  box-shadow: ${colors.goodBoxShadow};
  border-radius: 5px;
  color: ${colors.goodBlack};
  .profile-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    h3 {
      margin-left: 30px;
    }
    button {
      background-color: ${colors.lightGreen};
      color: ${colors.mainGreen};
      border: none;
      padding: 10px 20px;
      border-radius: 5px;
      margin-right: 30px;
    }
  }
  h3 {
    margin-left: 30px;
    margin-bottom: 20px;
  }
  hr {
    width: 100%;
    height: 1px;
    border: none;
    background-color: ${colors.middleGray};
    margin-bottom: 50px;
  }
  .integrations-card-wrapper {
    padding-left: 30px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    h3 {
      margin-left: 0;
    }
    .inner-wrapper {
      margin-right: 20px;
      margin-bottom: 25px;
    }
  }
  .profile-info-wrapper {
    padding: 0 40px;
    position: relative;
  }
  .pfp {
    width: 145px;
    height: 145px;
    min-width: 145px;
    min-height: 145px;
    border-radius: 100%;
    margin-left: 2px;
    cursor: pointer;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      border-radius: 100%;
    }
  }
  .profile-pic {
    input {
      display: none;
    }
    label {
      background-color: ${colors.darkGray};
      position: absolute;
      bottom: -30px;
      cursor: pointer;
      left: 50%;
      transform: translate(-50%, -50%);
      border: none;
      color: ${colors.white};
      width: 100px;
      padding: 10px;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      svg {
        width: 20px;
        height: 20px;
        margin-right: 5px;
        path {
          fill: ${colors.white};
        }
      }
    }
  }
  .dual-input-wrapper {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    max-width: 900px;
    .small-input {
      width: 400px;
    }
  }
  .disabled {
    position: relative;
    z-index: 10;
    pointer-events: none;
    margin-bottom: 25px;
    h4 {
      margin-bottom: -15px;
      max-width: 550px;
      margin-top: -10px;
      font-size: 17px;
    }
  }
  .edit-wrapper {
    margin-top: 40px;
    position: relative;
  }
  .display-wrapper {
    margin-top: 40px;
    position: relative;
  }
  .letter-wrapper {
    width: 145px;
    height: 145px;
    min-width: 145px;
    min-height: 145px;
    border-radius: 100%;
    background-color: ${colors.mainGreen};
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 40px;
    font-weight: 500;
  }
`;

interface IntegrationcardProps {
  enabled: boolean | undefined | string;
}

export const IntegrationCard = styled.div<IntegrationcardProps>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 550px;
  height: 160px;
  margin-bottom: 24px;
  padding: 24px;
  border-radius: 16px;
  position: relative;
  z-index: 10;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.04);
  background-color: white;
  transition: all 0.2s ease-in-out;

  &:hover {
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }

  p {
    color: ${colors.goodBlack};
    margin-top: 0px;
    margin-bottom: 6px;
    line-height: 1.4;
  }
  ${(props) =>
    props.enabled &&
    `
    background-color: #2c3e50;
    border: 1px solid rgba(124, 223, 77, 0.3);
    p {
      color: white;
    }
  `}
  .icon-wrapper {
    width: 48px;
    height: 48px;
    min-width: 48px;
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${props => props.enabled ? 'white' : 'transparent'};
    border-radius: 8px;
    ${props => props.enabled && `
      padding: 8px;
    `}
    svg {
      height: ${props => props.enabled ? '32px' : '48px'};
      width: ${props => props.enabled ? '32px' : '48px'};
      .rect {
        fill: ${props => props.enabled ? 'transparent' : 'white'};
      }
    }
  }
  .text-wrapper {
    flex: 1;
    margin-right: 16px;
    p:first-child {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 8px;
    }
    p:last-child {
      font-size: 14px;
      opacity: 0.8;
      line-height: 1.5;
    }
  }
  .button-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 85px;
    position: relative;
  }
  .disable {
    font-size: 13px;
    margin-top: 10px;
    cursor: pointer;
    color: ${props => props.enabled ? '#ff6b6b' : '#ff4444'};
    font-weight: 500;
    transition: all 0.2s ease-in-out;
    text-decoration: none;
    padding: 4px 8px;
    border-radius: 4px;
    &:hover {
      background-color: ${props => props.enabled ? 'rgba(255, 107, 107, 0.15)' : 'rgba(255, 68, 68, 0.1)'};
      text-decoration: underline;
    }
  }
  .overlay {
    position: absolute;
    top: 0;
    border-radius: 16px;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(2px);
    pointer-events: none;
    z-index: 1000;
  }
  button {
    padding: 8px 16px;
    border-radius: 8px;
    border: none;
    font-weight: 500;
    font-size: 14px;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    width: fit-content;
    min-width: 85px;
    ${(props) =>
      !props.enabled
        ? `
        color: ${colors.mainGreen};
        background: ${colors.lightGreen};
        &:hover {
          background: linear-gradient(135deg, #7cdf4d 0%, #4cabca 100%);
          color: white;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(124, 223, 77, 0.3);
        }
  `
        : `
  color: #7cdf4d;
  background: rgba(124, 223, 77, 0.1);
  border: 1.5px solid #7cdf4d;
  cursor: default;
  pointer-events: none;
  &::before {
    content: "✓";
    margin-right: 6px;
    font-weight: 600;
  }
  `}
  }
`;

export const OrganizationWrapper = styled.div`
  width: 100%;
  background-color: white;
  border-radius: 5px;
  box-shadow: ${colors.goodBoxShadow};
  color: ${colors.goodBlack};
  padding: 20px;
  .manage-teams {
    width: 132px;
    height: 36px;
    margin-left: 30px;
    padding: 6px 12px 6px 12px;
    gap: 6px;
    border: 1px solid ${colors.white};
    color: ${colors.white};
    border-radius: 5px;
    background-color: ${colors.middleGray};
    &:hover {
      color: ${colors.black};
      background-color: ${colors.white};
    }
  }
  .method-select-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 25px;
    select {
      margin-left: 10px;
    }
  }
  .user-table-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px auto;
  }
  .invite {
    width: 132px;
    height: 36px;
    padding: 6px 12px 6px 12px;
    gap: 6px;
    color: ${colors.mainGreen};
    border-radius: 5px;
    background-color: ${colors.lightGreen};
    border: none;
    &:hover {
      color: ${colors.black};
      background-color: ${colors.white};
    }
  }
`;

interface UserRowProps {
  header?: boolean;
  isCurrentUser?: boolean;
  highlighted?: boolean;
}

export const UserRowWrapper = styled.div<UserRowProps>`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 6px;
  transition: all 0.2s ease-in-out;
  position: relative;
  cursor: default;

  .trash { 
    svg {
      height: 20px;
      width: 20px;
    }
  }
  
  ${(props) =>
    props.header
      ? `
        margin-bottom: 8px; 
        p { 
          margin: 0;
          font-size: 14px;
          font-weight: 600;
          color: ${colors.middleGray};
          text-transform: uppercase;
          letter-spacing: 0.5px;
          white-space: nowrap;
          overflow: visible;
        }
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        padding: 8px 16px;
      `
      : `
        font-size: 15px; 
        font-weight: 400;
        &:hover {
          background-color: rgba(124, 223, 77, 0.08);
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        }
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
      `}
  
  ${(props) => props.isCurrentUser && `
    background-color: rgba(124, 223, 77, 0.12);
  `}
  
  ${(props) => props.highlighted && `
    background-color: rgba(124, 223, 77, 0.12);
  `}
  
  .close-wrapper {
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }
  
  &:hover .close-wrapper {
    opacity: 1;
  }
  
  .profile-icon {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    min-width: 40px;
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, #7cdf4d 0%, #4cabca 100%);
    color: white;
    font-weight: 600;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    
    ${(props) => props.header && `
      background: transparent;
      box-shadow: none;
    `}
    
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
    }
    
    h2 {
      font-size: 16px;
      font-weight: 600;
      margin: 0;
      text-align: center;
    }
  }
  
  .space {
    height: 24px;
    width: 24px;
    min-height: 24px;
    min-width: 24px;
  }
  
  .svg-wrapper {
    width: 24px;
    height: 24px;
    min-height: 24px;
    min-width: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    
    svg {
      height: 20px;
      width: 20px;
      min-height: 20px;
      min-width: 20px;
      
      path {
        stroke: ${colors.middleGray};
        transition: stroke 0.2s ease-in-out;
      }
    }
    
    &:hover svg path {
      stroke: #ff6b6b;
    }
  }
  
  h2 {
    font-size: 15px;
    line-height: 24px;
    font-weight: 500;
    text-align: left;
    margin: 0;
  }
  
  p {
    line-height: 20px;
    text-align: left;
    margin: 0;
    color: ${colors.goodBlack};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .email {
    width: 30%;
    color: ${colors.darkGray};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .role {
    width: 15%;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .name {
    width: 20%;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .active {
    width: 8%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .team {
    width: 15%;
    color: ${colors.darkGray};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const UserTableWrapper = styled.div`
  width: 100%;
  border-radius: 12px;
  background-color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 16px;
  margin-bottom: 24px;
  
  hr {
    border: none;
    height: 1px;
    background-color: #EAEDF0;
    width: 100%;
    margin: 8px 0 16px;
  }
`;

export const DragHandle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.2;
  cursor: grab;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 1;
  }
  
  svg {
    width: 16px;
    height: 16px;
    color: ${colors.middleGray};
  }
`;

export const RoleSelect = styled.div`
  position: relative;
  
  select {
    appearance: none;
    background-color: rgba(51, 51, 51, 0.05);
    border: 1px solid rgba(51, 51, 51, 0.1);
    border-radius: 6px;
    padding: 6px 32px 6px 12px;
    font-size: 14px;
    color: ${colors.goodBlack};
    width: 100%;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover, &:focus {
      border-color: rgba(124, 223, 77, 0.5);
      outline: none;
    }
    
    option {
      padding: 8px;
    }
  }
  
  &::after {
    content: '';
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid ${colors.middleGray};
    pointer-events: none;
  }
`;

export const StatusBadge = styled.span<{ status: 'Active' | 'Invited' }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  
  ${props => props.status === 'Active' ? `
    background-color: rgba(124, 223, 77, 0.15);
    color: #2c8a00;
    
    &::before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #2c8a00;
      margin-right: 6px;
    }
  ` : `
    background-color: rgba(255, 170, 0, 0.15);
    color: #b26000;
    
    &::before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #b26000;
      margin-right: 6px;
    }
  `}
`;

export const MemberHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  
  h2 {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
    color: ${colors.goodBlack};
  }
  
  button {
    background-color: ${colors.lightGreen};
    color: ${colors.mainGreen};
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 6px;
    
    svg {
      width: 16px;
      height: 16px;
    }
    
    &:hover {
      background-color: rgba(124, 223, 77, 0.3);
    }
  }
`;

export const InviteModal = styled.div`
  height: 70vh;
  position: relative;
  width: 50%;
  min-height: 744px;
  margin: 0 auto;
  background-color: white;
  border-radius: 5px;
  max-width: 600px;
  z-index: 1000;
  padding: 85px;
  color: ${colors.goodBlack} !important;
  padding: 30px 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  .label {
    color: ${colors.goodBlack} !important;
  }
  h3 {
    width: 100%;
    text-align: center;
  }
  .input-wrapper {
    width: 100%;
  }
  .submit-button {
    color: linear-gradient(180deg, #7cdf4d 0%, #4cabca 100%);
    background: none;
    width: 90%;
    margin: 0 auto;
    height: 50px;
    border-width: 2px;
    border-style: solid;
    border-image: linear-gradient(
      180deg,
      #7cdf4d 0%,
      #4cabca 100%
    ); /* Gradient colors */
    border-image-slice: 1; /* Ensure the gradient is applied to the entire border */
    padding: 10px 20px; /* Add padding to make the button visible */
    background-color: transparent; /* Transparent background to see the gradient border */
    color: white; /* Text color */
    font-size: 16px; /* Font size */
    cursor: pointer; /* Cursor style */
    border-radius: 5px;
    background-clip: padding-box;
    background: linear-gradient(
      180deg,
      #7cdf4d 0%,
      #4cabca 100%
    ); /* Gradient background */
    -webkit-background-clip: text; /* Clip the gradient to the text */
    -webkit-text-fill-color: transparent; /* Make the text transparent */
    color: transparent;
    &:hover {
      -webkit-background-clip: unset; /* Clip the gradient to the text */
      -webkit-text-fill-color: unset;
      color: #333;
    }
  }
`;

export const TeamsWrapper = styled.div`
  p {
    line-height: 24px;
    text-align: left;
    margin: 10px 0;
  }
  .email {
    width: 25%;
  }
  .role {
    width: 15%;
  }
  .name {
    width: 18%;
  }
  .active {
    width: 20%;
  }
  .edit {
    justify-content: flex-start;
  }
  .user-table {
    margin-bottom: 50px;
  }
`;
